export enum DiscountType {
  Amount = 'Amount',
  Percentage = 'Percentage'
}

export enum DiscountTypeOptions {
  Dollars = 'Dollars',
  Percent = 'Percent'
}
